import { AfterContentInit, OnDestroy } from '@angular/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ComponentOutputStatus } from '../../normalizzazione/component-output-status';
import { ContattoDTO } from '../../models/contatto-dto';
import { MessageService } from '../../services/message.service';
import { Recapito } from '../../models/portale/recapito';

@Component({
	selector: 'lib-contatti',
	templateUrl: './contatti.component.html',
	styleUrls: ['./contatti.component.css']
})
export class ContattiComponent implements OnInit, OnDestroy, AfterContentInit {

	form: FormGroup;

	@Input() recapiti$: Observable<Array<Recapito>>;

	@Input() contatti: ContattoDTO;

	@Output()
	done: EventEmitter<ComponentOutputStatus<ContattoDTO>> = new EventEmitter<ComponentOutputStatus<ContattoDTO>>();

	subscription: Subscription;

	listaEmail$: Observable<Array<Recapito>>;
	listaPec$: Observable<Array<Recapito>>;
	listaTelefono$: Observable<Array<Recapito>>;


	constructor(
		private msg: MessageService) { }

	ngOnInit() {

		// console.log('[ContattoDTO]', this.contatti);

		this.form = new FormGroup({});

		if (this.recapiti$) {
			this.initContatto();
		}

		const email = new FormControl({ value: this.contatti.email, disabled: false });
		this.form.addControl('email', email);

		const pec = new FormControl({ value: this.contatti.pec, disabled: false });
		this.form.addControl('pec', pec);

		const telefono = new FormControl({ value: this.contatti.telefono, disabled: false });
		this.form.addControl('telefono', telefono);

		const changes$ = this.form.valueChanges.pipe(
			map(_ => {
				const contattoNew = new ContattoDTO();
				contattoNew.email = email.value;
				contattoNew.pec = pec.value;
				contattoNew.telefono = telefono.value;
				return ComponentOutputStatus.of(
					this.form.valid, contattoNew);
			}));

		this.form.setValidators(form => {
			return (!form.get('pec').value && !form.get('email').value) ?
				{ requiredMail: true } : null;
		});

		this.subscription = changes$.subscribe(newContact => this.done.emit(newContact));
	}

	initContatto() {

		this.listaEmail$ = this.recapiti$.pipe(
			map(r => r.filter(t => t.tipoRecapito.codice == "EMAIL"))
		);

		this.listaPec$ = this.recapiti$.pipe(
			map(r => r.filter(t => t.tipoRecapito.codice == "PEC"))
		);

		this.listaTelefono$ = this.recapiti$.pipe(
			map(r => r.filter(
				t =>
					t.tipoRecapito.codice == "PHONE" ||
					t.tipoRecapito.codice == "CELL")
			)
		);
		// console.log('[listaTelefono]', this.listaTelefono);
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	ngAfterContentInit(): void {
		this.form.updateValueAndValidity({ emitEvent: true });
	}
}
